import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

import profileIcon from "../../../assets/icons/profile-icon.svg";
import { useUserProfile } from "../../../auth.user";
import { useUserCapabilities } from "../../../auth.capabilities";
import "./MobileProfileMenu.css"
import {
  adminMenuList,
  internalUserMenuList,
  externalUserMenuList,
} from "../Utils";

const MobileProfileMenu = ({ onClose }) => {
  const { instance } = useMsal();
  const { name, profile, loading } = useUserProfile();
  const { hasAdminRights, hasInternalUserRights, role } =
    useUserCapabilities();

  const userName = !loading && profile?.id
    ? `${profile.givenName} ${profile.surname}`
    : name;

  const userAvatar =
    !loading && profile?.photoUrl ? profile.photoUrl : profileIcon;

  const capitalizedRole = role
    ? role.charAt(0).toUpperCase() + role.slice(1).replace(/-/g, " ")
    : "";

  const menuList = hasAdminRights
    ? adminMenuList
    : hasInternalUserRights
    ? internalUserMenuList
    : externalUserMenuList;

  const handleLogout = (e) => {
    e.preventDefault();
    instance.logoutRedirect();
  };

  return (
    <div className="mobile-profile">
      {/* Header */}
      <div className="profile-header">
        <Image className="profile-avatar" src={userAvatar} />
        <div>
          <div className="profile-name">{userName}</div>
          <div className="profile-role">{capitalizedRole}</div>
        </div>
      </div>

      {/* Menu */}
      <div className="profile-menu">
        {menuList.map((item) => (
          <NavLink
            key={item.label}
            to={item.path}
            className="profile-menu-item"
            onClick={(e) => {
              if (item.label === "Sign out") {
                handleLogout(e);
              }
              onClose();
            }}
          >
            <Image src={item.icon} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default MobileProfileMenu;
